import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class TextQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.TEXT;
  type: string;
  min?: number;
  max?: number;
  minIndicative?: number;
  maxIndicative?: number;
  unit?: string;

  constructor(options: any = {}) {
    super(options);
    this.min = options['min'];
    this.max = options['max'];
    this.minIndicative = options['minIndicative'];
    this.maxIndicative = options['maxIndicative'];
    this.type = options['type'] || 'text';
    this.unit = options['unit'];
  }
}
